'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoThumbsdown = function IoThumbsdown(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm6.9 19.8c-0.8-0.4-1.4-1.4-1.4-2.3 0-1.1 0.6-2 1.5-2.3-0.3-0.4-0.4-1-0.4-1.5 0-1.1 0.6-2 1.5-2.4-0.2-0.4-0.4-0.8-0.4-1.3 0-1.4 0.9-1.9 2.8-2.3s5.7-1 9.8-0.7c1.8 0 4.3 0.5 6 0.5v-2.5h8.7v18.8h-8.7v-1.3c-1.2 0.1-2.5 0.3-3.2 1.1-1.7 1.8-3.1 5.1-3.1 8.4 0 1.5 0.1 2.3-0.3 2.7-1 1-3.4-0.7-4.1-2.9-0.7-2.7-0.1-4.8 0.1-6.8h-8c-1.5 0-2.7-1.2-2.7-2.7 0-1.1 0.8-2.2 1.9-2.5z m24.4-12.3c-0.8 0-1.3 0.5-1.3 1.3s0.5 1.2 1.3 1.2 1.2-0.5 1.2-1.2-0.5-1.3-1.2-1.3z' })
        )
    );
};

exports.default = IoThumbsdown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/thumbsdown.js
// module id = 2741
// module chunks = 0